<template>
  <div>
    <!-- API error -->
    <span v-if="$store.state.isSyncing === 3 && !$store.state.socketDisconnect">
      <i class="fas fa-times-circle fa-fw" />
      <span>{{ $t('Something went wrong') }}</span>&nbsp;
    </span>

    <!-- Socket error -->
    <span v-if="$store.state.socketDisconnect && $store.state.isSyncing !== 3">
      <span class="loading-spinner black mb--2px" />
      <span>{{ $t("connectionLost") }}</span>&nbsp;
    </span>

    <button class="btn btn-outline-dark btn-sm btn-reload" @click="reloadPage">
      {{ $t('Reload') }}
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    reloadPage() {
      window.location.reload()
    },
  },
}
</script>
